const normalizeString = (value) => String(value || '').trim().toLowerCase();

const resolveDateKey = (value) => {
  const raw = String(value || '').trim();
  if (raw === '') {
    return '';
  }

  const match = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? String(match[1]).trim() : '';
};

const formatDateForFilter = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const buildCurrentMonthRange = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  return {
    date_from: formatDateForFilter(new Date(year, month, 1)),
    date_to: formatDateForFilter(new Date(year, month + 1, 0)),
  };
};

export const createDefaultExpenseReceiptsToolbarFilters = () => ({
  ...buildCurrentMonthRange(),
  supplier_ids: [],
  collaborator_ids: [],
  payment_account_ids: [],
});

export const normalizeExpenseReceiptsToolbarFilters = (filters) => {
  const safeFilters = filters && typeof filters === 'object' ? filters : {};

  return {
    date_from: String(safeFilters.date_from || '').trim(),
    date_to: String(safeFilters.date_to || '').trim(),
    supplier_ids: Array.isArray(safeFilters.supplier_ids) ? safeFilters.supplier_ids : [],
    collaborator_ids: Array.isArray(safeFilters.collaborator_ids) ? safeFilters.collaborator_ids : [],
    payment_account_ids: Array.isArray(safeFilters.payment_account_ids) ? safeFilters.payment_account_ids : [],
  };
};

const matchesDateRange = (row, dateFrom, dateTo) => {
  if (!dateFrom && !dateTo) {
    return true;
  }

  const rowDateKey = resolveDateKey(row?.date);
  if (rowDateKey !== '') {
    if (dateFrom && rowDateKey < dateFrom) {
      return false;
    }

    if (dateTo && rowDateKey > dateTo) {
      return false;
    }

    return true;
  }

  const rowDate = new Date(String(row?.date || ''));
  if (Number.isNaN(rowDate.getTime())) {
    return false;
  }

  const startDate = dateFrom ? new Date(`${dateFrom}T00:00:00`) : null;
  const endDate = dateTo ? new Date(`${dateTo}T23:59:59`) : null;

  if (startDate && rowDate < startDate) {
    return false;
  }

  if (endDate && rowDate > endDate) {
    return false;
  }

  return true;
};

const includesValue = (selectedValues, value) => {
  if (!Array.isArray(selectedValues) || selectedValues.length === 0) {
    return true;
  }

  return selectedValues.map((item) => String(item)).includes(String(value));
};

export const filterExpenseReceiptsRowsByToolbar = (rows, { search, filters }) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const normalizedSearch = normalizeString(search);
  const normalizedFilters = normalizeExpenseReceiptsToolbarFilters(filters);

  return safeRows.filter((row) => {
    if (normalizedSearch !== '') {
      const haystack = [
        row?.folio,
        row?.supplier_name,
        row?.collaborator_name,
        row?.collaborator_full_name,
        row?.payment_account,
        row?.bank_account,
        row?.total,
      ]
        .map((item) => normalizeString(item))
        .join(' ');

      if (!haystack.includes(normalizedSearch)) {
        return false;
      }
    }

    if (!matchesDateRange(row, normalizedFilters.date_from, normalizedFilters.date_to)) {
      return false;
    }

    if (!includesValue(normalizedFilters.supplier_ids, row?.supplier_id)) {
      return false;
    }

    if (!includesValue(normalizedFilters.collaborator_ids, row?.collaborator_id)) {
      return false;
    }

    if (!includesValue(normalizedFilters.payment_account_ids, row?.payment_account_id)) {
      return false;
    }

    return true;
  });
};
